function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M40.28,5.55a3.26,3.26,0,0,0-1.46,6.19L32,18.29l-9.21-10a4.2,4.2,0,1,0-2,0l-9.21,10L4.83,11.69a3.25,3.25,0,1,0-1.56.41,2.23,2.23,0,0,0,.27,0L7.26,26.83H7a3.28,3.28,0,1,0,0,6.55h29.6a3.28,3.28,0,0,0,0-6.55H36.3l3.83-14.74h.15a3.28,3.28,0,0,0,0-6.55ZM1,8.83A2.28,2.28,0,1,1,3.89,11a.45.45,0,0,0-.23,0h0a2.33,2.33,0,0,1-.38,0A2.27,2.27,0,0,1,1,8.83ZM18.58,4.2a3.2,3.2,0,1,1,3.2,3.2A3.2,3.2,0,0,1,18.58,4.2ZM38.83,30.1a2.14,2.14,0,0,1-2.25,2.28H7a2.28,2.28,0,1,1,0-4.55h29.6A2.14,2.14,0,0,1,38.83,30.1Zm-3.56-3.27h-27L4.83,13.08l6.42,6.28a.6.6,0,0,0,.36.14.48.48,0,0,0,.36-.16L21.78,8.67l9.8,10.67a.48.48,0,0,0,.36.16.5.5,0,0,0,.36-.14l6.53-6.24Zm5-15.73a2.28,2.28,0,1,1,2.27-2.27A2.28,2.28,0,0,1,40.28,11.1Z"
})));

var SvgCrown = function SvgCrown(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 43.55 33.38",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crown.c978426f.svg";
export { ForwardRef as ReactComponent };